import { useLazyQuery } from '@apollo/client'
import PropTypes from 'prop-types'
import React from 'react'

import { GET_CUSTOMER_ORDER } from '../../../../graphql/queries/Customer'
import useCamelGraphQl from '../../../../hooks/useCamelGraphQl'
import ShipmentsContainer from './ShipmentsContainer'

const CustomerShipmentsContainer = ({ orderId }) => {
  const [getCustomerOrder, { data }] = useLazyQuery(GET_CUSTOMER_ORDER, {
    variables: {
      orderId,
    },
  })

  useCamelGraphQl(getCustomerOrder)

  const order = data && data.getCustomerOrder

  return <ShipmentsContainer order={order} urlFragment="orders" />
}

CustomerShipmentsContainer.defaultProps = {}

CustomerShipmentsContainer.propTypes = {
  orderId: PropTypes.string.isRequired,
}

export default CustomerShipmentsContainer
